<style lang="scss" scoped>
	// @import "./establishPage.css";
	@import "./custinforma.css";
</style>
<template>
	<div id="custinforma">
		<div class="topHeader">
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
						<a-row type='flex' justify='space-between'>
							
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="證券帳號" class="formItem">
									<a-input v-model="params.username" placeholder="請輸入證券帳號" />
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="签署文件" class="formItem">
									<a-input v-model="params.stockcode" placeholder="請輸入签署文件" />
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="剩余期限" class="formItem">
									<a-input v-model="params.stockcode" placeholder="請輸入剩余期限" />
								</a-form-model-item>
							</a-col>
							
							</a-row>
							<br>
							<a-row type='flex' justify='space-between'>
								<a-col :xl="{ span: 6 }">
									<a-form-model-item label="签署状态" class="formItem">
										<a-select v-model="params.status" placeholder="請選擇签署状态" @change="searchEvent">
											<a-select-option v-for="(item) in admintypeArr" :key="item" :value="item">
												{{item}}</a-select-option>
										</a-select>
									</a-form-model-item>
								</a-col>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="提交時間" class="formItem">
								<!-- 	<a-range-picker :placeholder="['開始時間','結束時間']" format="YYYY/MM/DD"
										v-model="params.timeDate" @change='fanhand'>
									</a-range-picker> -->
									<a-date-picker v-model="params.createtime" @change="fanhand" placeholder='請選擇提交時間'/>
								</a-form-model-item>
							</a-col>
							<!-- <a-col :xl="{ span: 6 }">
								<a-form-model-item label="審批時間" class="formItem">
									<a-date-picker v-model="params.handletime" @change="fanhand" placeholder='請選擇審批時間'/>
								</a-form-model-item>
							</a-col> -->
							<a-col :xl="{ span: 6 }">
								<a-button class="topBtn" style="background-color:#3bc7a1;margin-right: 2rem;" @click="searchEvent">
									<img src="../../image/icon_sousuo.png" class="btnIcon" />
									<span>搜索</span>
								</a-button>
								<a-button class="topBtn" style="background-color:#ffa647;margin-left:auto;"
									@click="clearEvent">
									<img src="../../image/icon_chongzhi.png" class="btnIcon" />
									<span>重置</span>
								</a-button>
							</a-col>
						</a-row>
			</a-form-model>
		</div>
		<div class="bottomMain">
			<div class="tableBtnView">
				<!-- <a-button class="bottomBtn" style="background-color:#ed4849;">
					<img src="../../image/icon_shanchu.png" class="btnIcon" />
					<span>刪除</span>
				</a-button> -->
				
				<!-- <a-upload name="file" :data='{token:$store.state.token}' :headers='{token:$store.state.token}'
					class="avatar-uploader" :show-upload-list="false" :action="$api.uploadPicwew"
					:before-upload="beforeUpload" @change="handleChange"> -->
					<!-- <a-button v-if='ipoAdmin' class="bottomBtn" style="background-color:rgb(88, 133, 234);">
						<img src="../../image/icon_daochu.png" class="btnIcon" />
						<span>導入</span>
					</a-button> -->
					<a-button v-if='ipoAdmin' class="bottomBtn" style="background-color:#349ce5;">
					<img src="../../image/icon_xiazai.png" class="btnIcon" />
					<span>導入</span>
				</a-button>
				<!-- </a-upload> -->
				<a-button class="bottomBtn" style="background-color:#3bc7a1;" @click='handpdf'>
					<img src="../../image/icon_daochu.png" class="btnIcon" />
					<span>導出</span>
				</a-button>
				<!-- <task :params='params' @child='fandfn'></task> -->
			</div>
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData"
				:customRow='rowstely'
				:rowKey='(record, index) => index' id='fromtable' :pagination="false" :bordered="true"
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }">
				<span slot='alltext' style="position: relative;left: -1.5rem;"></span>
				<div slot='tradetype' slot-scope="record"  >
				<!-- {{record.tradetype==1?"提款":"存款"}} :style="{color:record.tradetype==1?'green':'red'}"-->
				{{record.status}}
				</div>
				<!-- 显示状态 -->
				<div slot='stockname' slot-scope="record" >
					<!-- style="text-align: left;padding-left: 1.6rem;" -->
					{{record.stockname}}
				</div>
				<div slot='status' slot-scope="record" :style="{color:record.cancelflag==1?'#999':''}" style=' text-align: center;'>{{record.status}}
				</div>
				<div slot="schedule" slot-scope="record">
					<div class="tableRowView1">
						<img :src="record.schedule > 0? icon_one : icon_one1" alt="" class="imageC">
						<div class="lineC"
							:style="!(record.schedule == 1&&record.handle == 2)&&(record.schedule >= 1&&record.handle >= 1)||(record.schedule >= 1&&record.handle ==0)? 'background:#467fff;' : ''">
							<span v-if="record.schedule == 1&&record.handle == 2" class="redX">x</span>
						</div>
						<img :src="record.schedule > 1 ? icon_two : icon_two1" alt="" class="imageC">
						<div class="lineC" :style="!(record.schedule == 2&&record.handle == 2)&&(record.schedule >1&&record.handle == 1) ? 'background:#6cce68;' : ''">
							<span v-if="record.schedule == 2&&record.handle == 2" class="redX">x</span>
						</div>
						<img :src="record.schedule == 3? icon_three : icon_three1" alt="" class="imageC">
					</div>
				</div>
				<!-- 控制按鈕 -->
				<div slot="toolArr" slot-scope="record">
					<div class="tableRowView2">
						<div>
							<metemail :ipoAdmin='ipoAdmin' :record='record' :missionflag='params.missionflag'
								@child='handclose'></metemail>
						</div>
						<div class="popoverView">
							<ediotable :ipoAdmin='ipoAdmin' :record='record' @child='handclose' :missionflag='params.missionflag'></ediotable>
						</div>
						<!-- <div class="popoverView popoverView3">
							<metemails :ipoAdmin='ipoAdmin' :record='record' v-if='record.tradetype==1'
									  :missionflag='params.missionflag'
									  @child='handclose'></metemails>
							<pushbtn :record='record' @child='handclose' :params='params' v-else></pushbtn>
						</div> -->
					</div>
				</div>
			</a-table>
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
		</div>
		<div :class="['pdfview',pdfShow?'pdfShow':'']" @click='pdfShowUNEvent()'>
			<div class='pdfviewIn'>
				<div class='pdfTitle'>
					<img src="../../image/icon_dayin.png" alt=""  @click.stop="printEvent()">
				</div>
				<iframe id='iframePdf1' :src='allurl' style='width:100%;height:100%;' frameborder='0'></iframe>
				<iframe id='toPrintIframe' style='display:none' :src='pdfBolUrl' frameborder='0'></iframe>
			</div>
		</div>
	</div>
</template>
<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
	import icon_one from '../../image/icon_xinxi.png';
	import icon_one1 from '../../image/icon_xinxi1.png';
	import icon_two from '../../image/icon_shenhe.png';
	import icon_two1 from '../../image/icon_shenhe1.png';
	import icon_three from '../../image/icon_yinhang.png';
	import icon_three1 from '../../image/icon_yinhang1.png';

	import metemail from './components/metemail'
	import metemails from './components/metemails'
	import pushbtn from './components/pushbtn.vue'
	import ediotable from './components/ediotable.vue'
	import task from './components/task.vue'
	
	export default {
		components: {
			pushbtn,
			ediotable,
			metemail,
			metemails,
			task
		},
		data() {
			return {
				allurl:'',
				pdfShow:false,
				pdfBolUrl:'',
				pdfUrl : '',
				blob:'',
				icon_one,
				icon_one1,
				icon_two,
				icon_two1,
				icon_three,
				icon_three1,
				//: "編輯管理員": "ipoAdmin"有新增 编辑权限  审批管理员 审批权限
				ipoAdmin: this.$store.state.rolesdata.indexOf('ipoAdmin') >= 0,
				admintypeArr: [
					{v:'全部',x: ''},
					{v:'提交申請',x: '0'},
					{v:'申請成功',x: '1'},
					{v:'申請失敗',x: '2'},
					{v:'取消申請',x: '3'}
				],
				tradetypeArr:[
					{v:'全部',x: ''},
					{v:'存款',x: '0'},
					{v:'提款',x: '1'}
				],
				tzPageNum: '',
				selectedRows: [], //checkbox
				columns: [
					// {
					// 	// title: '',//
					// 	dataIndex: '',
					// 	align: 'left',
					// 	width: '4%',
					// 	slots: {
					// 		title: 'alltext'
					// 	},
					// 	// ellipsis:true,
					// },
					{
						title: '證券帳號',
						dataIndex: 'username',
						align: 'center',
						width: '11%'
					},
					{
						title: '签署文件',
						dataIndex: '',
						align: 'center',
						width: '15%',
						scopedSlots: {
							customRender: 'stockname'
						}
					},
					{
						title: '提交時間',
						dataIndex: 'createtime',
						align: 'center',
						width: '11%'
					},
					{
						title: '有效时间',
						dataIndex: 'stockcode',
						align: 'center',
						width: '11%'
					},
					
					{
						title: '剩余期限',
						dataIndex: 'amount',
						align: 'center',
						width: '11%'
					},
					
					
				
					{
						title: '签署状态',
						dataIndex: '',
						align: 'center',
						width: '11%',
						scopedSlots:{
							customRender:'tradetype'
						}
					},
					// {
					// 	title: '提存進度',
					// 	dataIndex: '',
					// 	align: 'center',
					// 	width: '20%',
					// 	scopedSlots: {
					// 		customRender: 'schedule'
					// 	}
					// },
					{
						title: '審批人員',
						dataIndex: 'handleadmin',
						align: 'center',
						width: '10%'
					},
					{
						title: '審批時間',
						dataIndex: 'handletime',
						align: 'center',
						width: '11%'
					},
					{
						title: '操作',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots: {
							customRender: 'toolArr'
						}
					},
				],
				columnsData: [],
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					stockcode: '',
					perPage: 10, //每頁條目數
					username: '',
					status: '',
					handletime:'',
					createtime: '', //認購起始日期
					missionflag: false,
					tradetype:''
				}
			}
		},
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.messLoad();
			// this.getlist()
		},
		methods: {
			handleChange(info) {
				if (info.file.response) {
					if (info.file.response.qmiscode == 1000) {
						this.loading = true;
						this.$message.success('導入成功');
						this.messLoad();
					} else {
						this.loading = false;
						this.$message.error(info.file.response.qmismsg);
					}
				}
			},
			beforeUpload(file) {
				var fileFormat = file.name
					.substring(file.name.lastIndexOf("."))
					.toLowerCase();
				const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
				if (!isJpgOrPng) {
					this.$message.error('只能上傳xls或xlsx文件!');
				}
				return isJpgOrPng;
			},
			handpdf(){
				let brr  = [];
				this.selectedRows.map(ev=>{
					if(this.columnsData[ev]['aduitid']){
						brr.push(this.columnsData[ev]['aduitid'])
					}
				})
				let str = this.$api.pdfs;
				let url = this.$api.getQmisUserTCPdf;
				
				url += '?stockcode='+this.params.stockcode
				url += '&username='+this.params.username
				url += '&status=' + this.params.status
				url += '&createtime=' + this.params.createtime
				url += '&handletime=' + this.params.handletime
		
				url += '&tradetype=' + this.params.tradetype
				url += '&token=' + this.$store.state.token
				url += '&idList=' + brr.join(',')
				url += '&m=' + Date.parse(new Date())
				this.allurl = str + url;
				let _this = this;
				_this.pdfUrl = url;
				https.fetchGetPdf(_this.pdfUrl).then((data)=>{
					let blob = new Blob([data],{
						type:'application/pdf'
					})
					let b=window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err=>{
					console.log(err)
				})
				setTimeout(()=>{
					this.pdfShow = true
				},500)
			},
			printEvent(){
			    let _this = this;
			    const printIframe = document.getElementById("toPrintIframe");
			    let frameWindow = printIframe.contentWindow;
			    frameWindow.print();
			    setTimeout(()=>{
			        window.URL.revokeObjectURL(_this.blob);
			    },500)
			},
			pdfShowUNEvent(){
				this.pdfShow = false
				this.messLoad()
			},
			rowstely(record, index) {
				if (record.schedule == 3||(record.schedule == 1&&record.handle == 2)
				||(record.schedule == 2&&record.handle == 2)) {
					return {
						style: {
							'color': '#999',
							opacity: '.5'
						},
					}
				}
			},
			fandfn(val) {
				if (val == 'back') {
					this.params.missionflag = false
					this.params.tradetype = ''
				} else {
					this.params.missionflag = true
					this.params.tradetype = val == '存款' ? '0' : '1'
				}
				this.messLoad()
			},
			getlist() {
				// this.$ajax({
				// 	method: 'post',
				// 	url: this.$api.getParamList,
				// 	headers: {
				// 		token: this.$store.state.token
				// 	},
				// 	data: {
				// 		"type": 'status'
				// 	}
				// }).then(res => {
				// 	if (res.data.qmiscode === 1000) {
				// 		this.admintypeArr = res.data.result
				// 	} else {
				// 		App.oTool.warningT(res.data.qmismsg);
				// 	}
				// })
			},
			//点击checkbox
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},
			//跳轉
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand(val) {
		
					//認購截止日期
					this.params.handletime = this.params.handletime ? App.oDate.secsTime3(this.params.handletime
						._d) : '';

				this.params.createtime = this.params.createtime ? App.oDate.secsTime3(this.params.createtime
						._d) : ''
					
			},
			handclose(val) {
				if(val){
					this.messLoad();
				}
			},
			messLoad() {
				this.params.token = this.$store.state.token
				this.$ajax({
					method: 'post',
					url: this.$api.getUserApplyRecordList,
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.userApplyList
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.params.missionflag = false;
				this.messLoad();
			},
			clearEvent() {
				this.params = {}
				this.params = {
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10, //每頁條目數
					username: '',
					status: '',
					createtime: '', //認購起始日期
					handletime: '', //認購截止日期
					missionflag: false
				}
				this.messLoad();
			},
			messionEvent() {
				this.params.pageNum = 1;
				this.params.missionflag = this.params.missionflag ? false : true
				this.messLoad();
			},
			substr(str, a, b) {
				return str.toString().substring(a, b)
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
		},
	};
</script>
<style lang='scss'>
	#custinforma {
		.pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 99;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.pdfview .pdfviewIn {
			position: fixed;
			width: 80vw;
			height: 80vh;
			left: calc(50% - 40vw);
			top: 5vh;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
	}
</style>